// extracted by mini-css-extract-plugin
export default {"productCardContainer":"productCard_productCardContainer__edywI","footer":"productCard_footer__BbFWF","name":"productCard_name__RZ5jq","price":"productCard_price__5dzDK"};